import { DataModelBuilder, isSameList, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { TicketTemplateRef } from '../../models/serializable/ticket-template';
import { MapUtils } from '../../utility/map-utils.js';
import { RenderableComponent } from '../core/component.js';

export class BuyTicketComponent extends RenderableComponent {
  static readonly TYPE_ID: string = 'd1f9270cde2f41a49aae79935c51a23a';
  static readonly DEFAULT_RENDER_ORDER: number = 16;

  constructor(
    public readonly eventId: string,
    public readonly eventWebRoute: string,
    public readonly ticketRefs: TicketTemplateRef[],
    public readonly renderOrder: number,
    public readonly isRenderingEnabled: boolean,
  ) {
    super();
  }

  get $typeId() {
    return BuyTicketComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static fromMap(context: SerializationContext, map: SerializedData): BuyTicketComponent {
    return new BuyTicketComponent(
        MapUtils.get<string>(map, 'eventId'),
        MapUtils.get<string>(map, 'eventWebRoute'),
        MapUtils.getList<TicketTemplateRef>(
            map,
            'ticketRefs',
            (value) => context.fromData<TicketTemplateRef>(value as SerializedData)
        ),
        MapUtils.get<number>(map, 'renderOrder'),
        MapUtils.get<boolean>(map, 'isRenderingEnabled'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'eventId': this.eventId,
      'eventWebRoute': this.eventWebRoute,
      'ticketRefs': this.ticketRefs.map((e) => context.toData(e)),
      'renderOrder': this.renderOrder,
      'isRenderingEnabled': this.isRenderingEnabled,
    };
  }

  clone(): this {
    return new BuyTicketComponent(
        this.eventId,
        this.eventWebRoute,
        this.ticketRefs.map((e) => e.clone()),
        this.renderOrder,
        this.isRenderingEnabled,
    ) as this;
  }

  isSame(other: BuyTicketComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.eventId === this.eventId &&
      other.eventWebRoute === this.eventWebRoute &&
      isSameList(other.ticketRefs, this.ticketRefs) &&
      other.renderOrder === this.renderOrder &&
      other.isRenderingEnabled === this.isRenderingEnabled;
  }
}

export class BuyTicketComponentBuilder extends DataModelBuilder<BuyTicketComponent> {
  build(context: SerializationContext, map: SerializedData): BuyTicketComponent {
    return BuyTicketComponent.fromMap(context, map);
  }
}
